<div
  class="button-container"
  [class.outline]="showOutlineOnHover"
>
  <button
    class="button"
    [style.background-color]="backgroundColor"
    [style.fontSize.px]="fontSize"
    [style.border]="border"
    [disabled]="disabled"
  >
    @if (iconLeft) {
      <i
        class="button-icon left"
        ngClass="{{ iconLeft }}"
        [style.color]="iconColor"
        [style.fontSize.px]="fontSize * 0.8"
        [style.transform]="rotate"
      ></i>
    }
    <span [style.color]="textColor">{{ label }}</span>
    @if (iconRight) {
      <i
        class="button-icon right"
        ngClass="{{ iconRight }}"
        [style.color]="iconColor"
        [style.fontSize.px]="fontSize * 0.8"
        [style.transform]="rotate"
      ></i>
    }
  </button>
  <ng-content></ng-content>
</div>
